// Centralized helpers for resolving Firestore paths with dynamic appId

export const APP_ID_STORAGE_KEY = 'acctoo_app_id';

export function getStoredAppId() {
  try {
    const fromWindow = typeof window !== 'undefined' ? (window.__APP_ID || null) : null;
    const fromStorage = typeof window !== 'undefined' ? (localStorage.getItem(APP_ID_STORAGE_KEY) || null) : null;
    return fromWindow || fromStorage || 'acc-app-e5316';
  } catch (_) {
    return 'acc-app-e5316';
  }
}

export function setStoredAppId(appId) {
  try {
    if (!appId) return;
    if (typeof window !== 'undefined') {
      window.__APP_ID = appId;
      try { localStorage.setItem(APP_ID_STORAGE_KEY, appId); } catch (_) {}
    }
  } catch (_) {}
}

export function resolveAppId(appIdOverride) {
  return appIdOverride || getStoredAppId();
}

export function userBasePath(userId, appIdOverride) {
  const appId = resolveAppId(appIdOverride);
  return `artifacts/${appId}/users/${userId}`;
}


